// Override Settings
var boostPFSFilterConfig = {
    general: {
        limit: boostPFSThemeConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        filterTreeMobileStyle: 'style1',
        showLimitList: '12,24,36',
        breakpointMobile: '959'
    },
};

(function () {
    var onSale = false,
        soldOut = false,
        priceVaries = false,
        images = [],
        firstVariant = {};

    BoostPFS.inject(this);
    boostPFSFilterConfig.general.separateRefineByFromFilter = jQ('.boost-pfs-filter-tree-h').length > 0 && jQ(window).width() > 767 ? true : false;

    /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    function prepareShopifyData(data) {
        // Displaying price base on the policy of Shopify, have to multiple by 100
        soldOut = !data.available; // Check a product is out of stock
        onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Convert images to array
        images = data.images_info;
        // Get First Variant (selected_or_first_available_variant)
        firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function (e) {
                return e.id == Utils.getParam('variant');
            });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        return data;
    }

    /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    /************************** BUILD PRODUCT LIST **************************/
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function (data) {
        if (!data) data = this.data;
        // Customize API data to get the Shopify data
        data = prepareShopifyData(data);

        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add Grid Width class
        itemHtml = itemHtml.replace(/{{itemGridClass}}/g, buildGridClass());

        // Add Grid Width class
        itemHtml = itemHtml.replace(/{{itemInfo}}/g, boostPFSTemplate.itemInfoHtml);

        // Add QuickShop
        itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, buildQuickShop(data));

        // Add Images
        itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

        // Add Swatches
        itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildSwatches(data));

        // Add Labels
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

        // Add Price
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

        // Add Origin
        itemHtml = itemHtml.replace(/{{itemOrigin}}/g, buildOrigin(data));


        // Add Review
        if (typeof Integration === 'undefined' ||
            (typeof Integration != 'undefined' &&
                typeof Integration.hascompileTemplate == 'function' &&
                !Integration.hascompileTemplate('reviews'))) {
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
        }



        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);

        if (data.tags.indexOf('Coming Soon') > -1) {
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, 'javascript:void(0);');
        }
        else {
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        }
        return itemHtml;
    };


    /************************** END BUILD PRODUCT LIST **************************/
    /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildGridClass() {
        var gridWidthClass = '';
        switch (boostPFSThemeConfig.custom.products_per_row) {
            case 2:
                gridWidthClass = 'w-50';
                break;
            case 3:
                gridWidthClass = 'w-50 w-third-m w-third-l';
                break;
            case 4:
            default:
                gridWidthClass = 'w-50 w-third-m w-25-l';
                break;
        }

        return gridWidthClass;
    }

    function buildQuickShop(data) {
        var html = '';

        if (!boostPFSConfig.custom.quick_shop_enabled) return html;

        html = '<button type="button" class="product-tile__quick-shop-button active bttn bttn--full">' +
            '  <span>' + boostPFSConfig.label.add_to_quick_shop + '</span>' +
            '</button>' +
            '<div class="quick-shop boost-pfs-quickshop-{{itemId}}"></div>';

        return html;
    }

    function buildImages(data) {
        var html = '';

        if (images.length > 1) {
            html += '<div class="product-tile__images ' + (soldOut ? 'o-70' : '') + '">';
            html += '  <a href="{{itemUrl}}">';
            html += '    <div class="product-tile__sizer">' + responsiveImage(images[0]) + '</div>';
            html += '    <div class="product-tile__image first">' + responsiveImage(images[0]) + '</div>';
            html += '    <div class="product-tile__image not-first">' + responsiveImage(images[1]) + '</div>';
            html += '  </a>';
            html += '</div>';
        } else {
            html += '<div class="product-tile__image ' + (soldOut ? 'o-70' : '') + '">';
            html += '  <a href="{{itemUrl}}">' + responsiveImage(images[0]) + '</a>';
            html += '</div>';
        }


        return html;
    }

    function responsiveImage(image) {
        if (!image) {
            image = {
                src: boostPFSConfig.general.no_image_url,
                width: 1024,
                height: 1024
            }
        }

        var aspectRatio = image.width / image.height;
        var maxWidth = 700;
        var maxHeight = 800;

        var maxWidthImage = maxWidth;
        var maxHeightImage = maxHeight;

        if (aspectRatio <= 1) {
            maxHeightImage = image.height;
            maxWidthImage = maxHeightImage * aspectRatio;
        } else {
            maxWidthImage = image.width > maxWidth ? maxWidth : image.width;
            maxHeightImage = maxWidthImage / aspectRatio;
        }

        var paddingTop = maxHeightImage / maxWidthImage * 100;
        var widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024];

        var imageWidths = widths.filter(w => w <= image.width);

        var html = boostPFSTemplate.imageHtml;
        html = html.replace(/{{image_id}}/g, image.id);
        html = html.replace(/{{counter}}/g, 0);
        html = html.replace(/{{max_width_image}}/g, maxWidthImage);
        html = html.replace(/{{max_height_image}}/g, maxHeightImage);
        html = html.replace(/{{padding_top}}/g, paddingTop);
        html = html.replace(/{{image_widths}}/g, imageWidths.toString());
        html = html.replace(/{{aspect_ratio}}/g, aspectRatio);
        html = html.replace(/{{image_url}}/g, Utils.optimizeImage(image.src, '1x1').replace('_1x1.', '_{width}x.'));
        html = html.replace(/{{image_url_300}}/g, Utils.optimizeImage(image.src, '300x300'));
        html = html.replace(/{{image_url_2048}}/g, Utils.optimizeImage(image.src, '2048x2048'));
        html = html.replace(/{{image_alt}}/g, image.alt || '{{itemTitle}}');

        return html;
    }

    function buildLabels(data) {
        var html = '';

        if (onSale && boostPFSConfig.custom.show_sale_badge) html += boostPFSTemplate.saleLabelHtml;
        if (soldOut && boostPFSConfig.custom.show_soldout_badge) html += boostPFSTemplate.soldOutLabelHtml;

        return html;
    }

    function buildOrigin(data) {
        var html = '';

        if (data.metafields.length > 0)
            html = '<div><span class="dc_product_origin">' + data.metafields[0].value + '</span></div>';


        return html;
    }

    function buildPrice(data) {
        var html = '';
        var compareAtPrice = Utils.formatMoney(data.compare_at_price_min);
        var price = Utils.formatMoney(data.price_min);

        if (onSale) {
            html += '<div class= "retail-price">';
            html += '  <span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
            html += '  ' + boostPFSConfig.label.traditional_retail;
            html += '  <span class="price-text-right">' + compareAtPrice + '</span>';
            html += '</div>';

            if (priceVaries) {
                html += boostPFSConfig.label.on_sale_from_html.replace(/{{ price }}/g, price);
            } else {
                html += '<div class="sale-black-box">';
                html += '  <span class="sale-black">' + boostPFSConfig.label.sale_msg + '</span>';
                html += '  <span class="sale-black price-text-right">' + price + '</span>';
                html += '</div>';
            }
        } else {
            if (priceVaries) {
                html += boostPFSConfig.label.from.replace(/{{ price }}/g, price);
            } else {
                html += price;
            }
        }

        return html;
    }


    // Build Swatches
    function buildSwatches(data) {
        var html = '';

        var options = (boostPFSConfig.custom.swatch_options || '').split(', ');
        if (!boostPFSConfig.custom.show_swatches || options.length === 0) return '';

        var option = data.options_with_values.find(o => options.includes(o.label));
        if (!option) return '';

        html += '<div class="product-tile__swatches">';

        for (var value of option.values) {
            var color = Utils.slugify(value.title);
            var filePath = Utils.getFilePath(color, 'png');

            html += '<div class="product-tile__swatch" ';
            html += '  style="background-image: url(' + filePath + ')"';
            html += '></div>';
        }

        html += '</div>';


        return html;
    }



    /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
    /************************** BUILD TOOLBAR **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        // If it has only one page, clear Pagination
        if (totalPage <= 1) {
            return '';
        }

        var paginationHtml = boostPFSTemplate.paginateHtml;

        var fromProduct = (currentPage - 1) * Globals.queryParams.limit + 1;
        var product_index = (currentPage - 1) * Globals.queryParams.limit + 1;
        var toProduct = product_index + this.data.products.length - 1;

        var pageInfoHtml = boostPFSConfig.label.page_info;
        pageInfoHtml = pageInfoHtml.replace(/{{ of }}/g, fromProduct + '-' + toProduct);
        pageInfoHtml = pageInfoHtml.replace(/{{ total }}/g, totalProduct + ' ' + (totalProduct > 1 ? boostPFSConfig.label.items_with_count_other : boostPFSConfig.label.items_with_count_one));


        paginationHtml = paginationHtml.replace(/{{pageInfo}}/g, pageInfoHtml);

        // Build Previous
        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }
        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
        var html = '';
        if (boostPFSThemeConfig.custom.show_sort && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                var paramSort = Globals.queryParams.sort || '';
                // Build content
                var sortingItemsHtml = '';
                var activeClass = '';
                for (var k in sortingArr) {
                    activeClass = '';
                    if (paramSort == k) {
                        activeClass = 'active';
                    }
                    sortingItemsHtml += '<li class="filter-item ' + activeClass + '" aria-label="' + sortingArr[k] + '">' +
                        '<a href="#" class="filter-item__content no-transition type-body-regular" data-sort="' + k + '" title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' +
                        '<div class="filter-input__input filter-item__radio"><div class="indicator"></div></div>' +
                        '<span class="filter-item__label type-body-regular">' + sortingArr[k] + '</span></a></li>';
                }
                html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            }
        }
        return html;
    };

    // Build Sorting event
    ProductSorting.prototype.bindEvents = function () {
        var _this = this;

        jQ('.boost-pfs-filter-top-sorting a').on('click', function (e) {
            e.preventDefault();
            FilterApi.setParam('sort', jQ(this).data('sort'));
            FilterApi.setParam('page', 1);
            FilterApi.applyFilter('sort');
        });
    };

    // Build Show Limit
    ProductLimit.prototype.compileTemplate = function () {
        var html = '';
        if (boostPFSThemeConfig.custom.show_limit) {

            var numberList = Settings.getSettingValue('general.showLimitList');
            if (numberList != '') {
                // Build content
                var showLimitItemsHtml = '';
                var arr = numberList.split(',');
                var activeClass = '';
                for (var k of arr) {
                    var value = k.trim();

                    activeClass = '';
                    if (value == Globals.queryParams.limit) {
                        activeClass = 'class="active"';
                    }

                    showLimitItemsHtml += '<a href="#" ' + activeClass + ' data-limit="' + value + '">' + value + '</a>';
                }
                html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
            }
        }
        return html;
    };

    ProductLimit.prototype.bindEvents = function () {
        jQ('.boost-pfs-filter-top-show-limit a').on('click', function (e) {
            e.preventDefault();
            FilterApi.setParam('limit', jQ(this).data('limit'));
            FilterApi.setParam('page', 1);
            FilterApi.applyFilter();
        });
    }


    /************************** END BUILD TOOLBAR **************************/

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function (data) {
        if (!data) data = this.data;

        document.dispatchEvent(new CustomEvent('shopify:section:load'))

        if (boostPFSConfig.custom.quick_shop_enabled) {
            this.buildExtrasProductListByAjax(data, 'boost-integration', function (results) {
                results.forEach(function (result) {
                    // Append the custom html to product item
                    jQ('.boost-pfs-quickshop-' + result.id).empty().html(result.custom_html);
                })
            });
        }
    };

    // Build additional elements
    Filter.prototype.afterRender = function (data) {
        if (!data) data = this.data;


    };


    /* Prevent conflict with theme vendor js */
    Array.prototype.insert = function (a, b) { }
})();